// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /round/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeRoundListBody,
  typeRoundListOutput200,
} from "../../sdk/round/postRoundList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildRoundListQueryKey(payload: typeRoundListBody): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return ["post:round:roundList", "svc:contest-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeRoundListOutput200,
    unknown,
    typeRoundListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useRoundList(
  payload: typeRoundListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildRoundListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postRoundList(payload),
    ...resolvedOptions,
  });
}
